import { NAME_MAX_LENGTH, PHONE_NUMBER_VALID_REGEX } from "src/constants";
import * as yup from "yup";
import { removeNonDigits } from "..";
import dayjs from "dayjs";

export const OPTIONAL_PATIENT_PARENT_VALIDATION_SCHEMA = yup.object().shape({
    firstName: yup.string().max(NAME_MAX_LENGTH),
    lastName: yup.string().max(NAME_MAX_LENGTH),
    email: yup.string().email(),
    mobilePhone: yup
        .string()
        .nullable()
        .notRequired()
        .transform((_, originalValue) => {
            return !originalValue ? null : removeNonDigits(originalValue);
        })
        .length(10)
        .matches(PHONE_NUMBER_VALID_REGEX, {
            message: "Not a valid phone number.",
            excludeEmptyString: true,
        }),
    dateOfBirth: yup
        .string()
        .test("validDate", "Date of birth is invalid.", (value) => !value || dayjs(value).isValid())
        .notRequired(),
});
// .notRequired();

export const PATIENT_VALIDATION_SCHEMA = yup.object().shape({
    firstName: yup.string().required().max(NAME_MAX_LENGTH),
    lastName: yup.string().required().max(NAME_MAX_LENGTH),
    email: yup.string().email(),
    mobilePhone: yup
        .string()
        .nullable()
        .notRequired()
        .transform((_, originalValue) => {
            return !originalValue ? null : removeNonDigits(originalValue);
        })
        .length(10)
        .matches(PHONE_NUMBER_VALID_REGEX, {
            message: "Not a valid phone number.",
            excludeEmptyString: true,
        }),
    receiveEmail: yup.boolean(),
    receiveSms: yup.boolean(),
    dateOfBirth: yup
        .string()
        .test("validDate", "Date of birth is invalid.", (value) => !value || dayjs(value).isValid())
        .notRequired(),
    parents: yup.array().of(
        yup.object().shape({
            parentAccountPatientId: yup.number(),
            parentRelationshipName: yup.string(),
        }),
    ),
    parent: OPTIONAL_PATIENT_PARENT_VALIDATION_SCHEMA,
    accountPatientId: yup.number().notRequired(),
});

export const PATIENT_SCHEDULING_PATIENT_DETAILS_SCHEMA = yup.object().shape({
    firstName: yup.string().required().max(NAME_MAX_LENGTH),
    lastName: yup.string().required().max(NAME_MAX_LENGTH),
    email: yup.string().email().nullable(),
    mobilePhone: yup
        .string()
        .nullable()
        .notRequired()
        .transform((_, originalValue) => {
            return !originalValue ? null : removeNonDigits(originalValue);
        })
        .length(10)
        .matches(PHONE_NUMBER_VALID_REGEX, {
            message: "Not a valid phone number.",
            excludeEmptyString: true,
        }),
    dateOfBirth: yup
        .string()
        .test("validDate", "Date of birth is invalid.", (value) => !value || dayjs(value).isValid())
        .notRequired(),
    children: yup.array().of(
        yup.object().shape({
            childAccountPatientId: yup.number(),
            parentRelationshipName: yup.string(),
            isEdited: yup.boolean(),
            firstName: yup.string(),
            lastName: yup.string(),
            dateOfBirth: yup
                .string()
                .test(
                    "validDate",
                    "Date of birth is invalid.",
                    (value) => !value || dayjs(value).isValid(),
                )
                .notRequired(),
        }),
    ),
    accountPatientId: yup.number().notRequired(),
});

export const OPTIONAL_PATIENT_CHILD_VALIDATION_SCHEMA = yup
    .object()
    .shape({
        firstName: yup.string().max(NAME_MAX_LENGTH),
        lastName: yup.string().max(NAME_MAX_LENGTH),
    })
    .notRequired();

export const NONOPTIONAL_PATIENT_CHILD_VALIDATION_SCHEMA = yup.object().shape({
    firstName: yup.string().required().max(NAME_MAX_LENGTH),
    lastName: yup.string().required().max(NAME_MAX_LENGTH),
    dateOfBirth: yup
        .string()
        .test("validDate", "Date of birth is invalid.", (value) => !value || dayjs(value).isValid())
        .notRequired(),
    accountPatientId: yup.number().notRequired(),
    parentRelationshipName: yup.string().required().max(NAME_MAX_LENGTH),
    isEdited: yup.boolean().required(),
});
